/*
 * km2-image-zoom.js — a tiny shared click-to-zoom lightbox (owner 2026-07-02).
 *
 * Any element carrying [data-km2-zoom] opens a full-size view of its image over a dark
 * translucent backdrop; clicking the backdrop (or the close button, or pressing Esc)
 * closes it. Used for the CART line-item thumbnails (drawer + /cart page), which had no
 * zoom. The PDP keeps its existing PhotoSwipe gallery — this does NOT touch it.
 *
 * The click listener runs in the CAPTURE phase so it intercepts before the thumbnail's
 * wrapping <a> can navigate to the product page: the image zooms; the product-name link
 * beside it still goes to the PDP.
 *
 * Full-size source: [data-km2-zoom-src] (a larger image_url) if present, else the img's
 * own src. Markup escapes the URL; this only reads attributes, never injects HTML.
 */
(function () {
  if (window.KM2ImageZoom) return;
  window.KM2ImageZoom = true;

  var overlay, figure, imgEl, lastFocus;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'km2-zoom-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product image');
    overlay.hidden = true;

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'km2-zoom-close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

    figure = document.createElement('div');
    figure.className = 'km2-zoom-figure';
    imgEl = document.createElement('img');
    imgEl.className = 'km2-zoom-img';
    imgEl.alt = '';
    figure.appendChild(imgEl);

    overlay.appendChild(close);
    overlay.appendChild(figure);
    document.body.appendChild(overlay);

    // Click anywhere that ISN'T the image itself closes (backdrop + close button).
    overlay.addEventListener('click', function (e) {
      if (e.target !== imgEl) closeZoom();
    });
  }

  function openZoom(src, alt) {
    if (!src) return;
    if (!overlay) build();
    lastFocus = document.activeElement;
    imgEl.src = src;
    imgEl.alt = alt || '';
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden'; // lock scroll behind
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      overlay.querySelector('.km2-zoom-close').focus();
    });
  }

  function closeZoom() {
    if (!overlay || overlay.hidden) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var settle = function () {
      overlay.hidden = true;
      imgEl.src = '';
      overlay.removeEventListener('transitionend', settle);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    overlay.addEventListener('transitionend', settle);
    setTimeout(settle, 260); // fallback if transitionend doesn't fire
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest ? e.target.closest('[data-km2-zoom]') : null;
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var src = trigger.getAttribute('data-km2-zoom-src')
      || (trigger.tagName === 'IMG' ? trigger.getAttribute('src') : '')
      || trigger.getAttribute('data-km2-zoom');
    var alt = trigger.getAttribute('alt') || '';
    openZoom(src, alt);
  }, true); // capture — beat the wrapping <a>

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeZoom();
  });
})();
